import patternsJson from "../../../shared/usb-controller-patterns.json";

const CONTROLLER_PATTERNS: [RegExp, string][] = patternsJson.map(
  ({ pattern, name }) => [new RegExp(pattern), name]
);

export function normalizeControllerName(raw: string): string {
  const match = CONTROLLER_PATTERNS.find(([pattern]) => pattern.test(raw));
  return match ? match[1] : raw;
}
